<script setup lang="ts">
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3";
import { createSocialBlock, createSocialsBlock } from "~/stores/mail-block-editor/defaults";
import { MailMjmlColumn, MailMjmlSection, MailMjmlImage } from "#components";

const store = useMailStore();
const props = defineProps(nodeViewProps);
const parent = computed(() => {
    return store.getParentBlock(props.node.attrs.id);
});

const findSocial = (url: string) => {
    let social = undefined;

    if(url.startsWith("{{")) {
        const match = store.fieldCollection.findMatches(url).items[0];
        
        if(match) {
            console.log(match);
            social = store.findMatchingSocial(match.default_value) ?? store.findMatchingSocial(match.metadata?.domain);
        }
    }

    if(social) {
        return social;
    }
    
    return store.findMatchingSocial(url) ?? store.findMatchingSocial("web");
};

const theme = computed(() => {
    const theme = store.fieldCollection.replaceContent(
        createSocialBlock(props.node.attrs),
    );

    const index = parent.value?.content?.findIndex(
        (child: any) => child.attrs.id === props.node.attrs.id,
    );
    const count = parent.value?.content?.length ?? 0;
    const gap = parent.value?.attrs?.gap ?? 4;
    const halfGap = gap / 2;

    const isFirstIndex = index === 0;
    const isLastIndex = index === count - 1;
    const hasManyItems = count > 1;

    let padding = "0px 0px 0px 0px";
    let textPadding = `0px 0px 0px ${gap}px`;

    if (parent.value?.attrs?.mode === "horizontal") {
        if (hasManyItems && isFirstIndex) {
            padding = `0px ${halfGap}px 0px 0px`;
        } else if (hasManyItems && isLastIndex) {
            padding = `0px 0px 0px ${halfGap}px`;
        } else if (hasManyItems) {
            padding = `0px ${halfGap}px 0px ${halfGap}px`;
        }
    } else if (hasManyItems && isFirstIndex) {
        padding = `0px 0px ${halfGap}px 0px`;
    } else if (hasManyItems && isLastIndex) {
        padding = `${halfGap}px 0px 0px 0px`;
    } else if (hasManyItems) {
        padding = `${halfGap}px 0px ${halfGap}px 0px`;
    }

    if (hasManyItems && isLastIndex) {
        textPadding = `0px 0px 0px ${halfGap}px`;
    } else if (hasManyItems) {
        textPadding = `0px ${halfGap}px 0px ${halfGap}px`;
    }

    let src = theme.src;
    const social = findSocial(props.node.attrs.url);

    if (!src) {
        src = social?.icon;
    }

    return {
        ...theme,
        src,
        gap,
        padding,
        textPadding,
    };
});

</script>

<template>
    <NodeViewWrapper
        class="social"
        @click.stop="store.focusedJsonId = node?.attrs?.id"
    >
        <MailMjmlImage
            :src="theme.src"
            height="var(--mj-icon-size)"
            width="var(--mj-icon-size)"
            class="pointer-events-none inline-block"
            :style="{ padding: theme.padding }"
        />
        <NodeViewContent
            class="social-content inline-block"
            :style="{ padding: theme.textPadding }"
        />
    </NodeViewWrapper>
</template>

<style scoped>
.social {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: var(--mj-font-size);

    &.is-empty > .social-content {
        padding: 0.01px !important;
    }
}
</style>
